// Yeni Kredi Kartı Ekle / Düzenle penceresi kullanım rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'finance.addCreditCard';

export const addCreditCardGuide = (t: TFunction): GuideContent => ({
  layout: 'dialog',
  title: t(`${G}.title`, 'Kredi kartı nasıl eklenir?'),
  intro: t(`${G}.intro`, 'Şirketin kullandığı bir kredi kartını sisteme tanımlar; sonra bu karta harcama ve ödeme kaydedebilirsiniz. Aynı pencere kartı düzenlemek için de açılır. Haritada bir bölgeye tıklayarak o adıma geçebilirsiniz.'),
  regionLabels: {
    header: t(`${G}.regions.header`, 'Başlık'),
    body: t(`${G}.regions.body`, 'Kart bilgileri'),
    footer: t(`${G}.regions.footer`, 'Kaydet'),
  },
  steps: [
    {
      region: 'body',
      title: t(`${G}.s1.title`, '1. Kartı tanımlayın'),
      text: t(`${G}.s1.text`, 'Hesap Adı (ör. Şirket Kredi Kartı) ve Kart Numarası zorunludur. Kart numarası yalnız rakam kabul eder, en fazla 16 hane yazılır ve 4\'erli gruplanır. Tanımı / Açıklama isteğe bağlıdır.'),
    },
    {
      region: 'body',
      title: t(`${G}.s2.title`, '2. Kesim ve son ödeme günü'),
      text: t(`${G}.s2.text`, 'Hesap Kesim Günü, bankanın ekstreyi kestiği ayın günüdür; Son Ödeme Günü, ekstre borcunun en geç ödeneceği gündür. İkisi de 1–31 arasından seçilir.'),
    },
    {
      region: 'body',
      title: t(`${G}.s3.title`, '3. Limit ve asgari ödeme'),
      text: t(`${G}.s3.text`, 'Kart Limiti zorunludur. Harcama eklerken kalan limitten büyük harcama kaydedilemez. Min. Ödeme Tutarı boş bırakılırsa asgari ödeme borcun %20\'si olarak hesaplanır.'),
      tips: [
        t(`${G}.s3.tip1`, 'Tutarları yalnız rakamla yazın; kuruş için nokta kullanın (ör. 50000.00).'),
      ],
    },
    {
      region: 'body',
      title: t(`${G}.s4.title`, '4. Para birimi, şube ve durum'),
      text: t(`${G}.s4.text`, 'Para Birimi listesinde Döviz sayfasında aktif ettiğiniz para birimleri çıkar. Şube seçimi isteğe bağlıdır; şube seçtiyseniz "Sadece Bu Şube" anahtarı açılabilir. Aktif / Pasif anahtarı kartın kullanımda olup olmadığını belirtir.'),
      tips: [
        t(`${G}.s4.tip1`, 'Şube yöneticisi olarak girdiyseniz kart sizin şubenize sabitlenir ve "Sadece Bu Şube" açık kalır.'),
        t(`${G}.s4.tip2`, 'Ek Bilgi / Notlar alanına kartla ilgili notları yazabilirsiniz.'),
      ],
    },
    {
      region: 'footer',
      title: t(`${G}.s5.title`, '5. Kaydedin'),
      text: t(`${G}.s5.text`, '"Kaydet" (düzenlemede "Güncelle") zorunlu alanlar dolunca açılır. Kart kaydedilince kart listesinde görünür; harcama, ödeme ve hareketleri oradan yönetirsiniz. Başlıktaki (i) bu rehberi yeniden açar.'),
    },
  ],
});
